/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_NoteInputs */

const en_directory_submit_review_note = /** @type {(inputs: Directory_Submit_Review_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every submission is reviewed by our editors. Paid plans may receive priority review, but payment does not guarantee acceptance.`)
};

const zh_directory_submit_review_note = /** @type {(inputs: Directory_Submit_Review_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有提交都会经过编辑审核。付费方案可获得优先审核，但付费不代表一定收录。`)
};

/**
* | output |
* | --- |
* | "Every submission is reviewed by our editors. Paid plans may receive priority review, but payment does not guarantee acceptance." |
*
* @param {Directory_Submit_Review_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_note = /** @type {((inputs?: Directory_Submit_Review_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_note(inputs)
	return zh_directory_submit_review_note(inputs)
});
export { directory_submit_review_note as "directory.submit.review_note" }